module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro2--euro@2-8b4f4e82d39aa016c4ca9f5c89941abc.jpg";